<div id="captchaJuncture" class="container">
  @if (!this.FlagService.flagServiceObject[9]['finalpaymentJunctureFlag']) {
    <div class="row">
      <div class="col-12 p-0">
        <div class="component-header __indicator">
          <h3 class="label m-0">{{ 'junctures.captcha.header' | translate }}</h3>
        </div>
      </div>
    </div>
  }

  @if (!this.FlagService.flagServiceObject[9]['finalpaymentJunctureFlag']) {
    <div class="row justify-content-md-center mb-4 mt-5">
      <div class="col-sm-10 col-md-8 mb-1 text-center">
        @if (this.captchaPath) {
          <img [src]="this.captchaPath" alt="captcha image" title="captcha image">
        }
        @if (!this.captchaPath) {
          <fa-icon class="faHourglass mb-3" [icon]="faHourglass"></fa-icon>
        }
      </div>
      <div class="col-sm-10 col-md-8">
        <div class="captcha-container mt-1">
          <input id="captchaInput" class="form-control" type="text" name="captcha" placeholder="{{ 'junctures.captcha.placeholder' | translate }}" (ngModelChange)="captchaInputChange($event)" [(ngModel)]="_captchaInput" [attr.disabled]="this.captchaPath? null : true">
          <button (click)="validateCaptcha()" type="button" class="btn ms-3" [ngClass]="{'disabled': !_captchaInputValid}">Ok</button>
          @if (this.captchaPath) {
            <button (click)="reloadCaptcha()" type="button" class="btn ms-2"><fa-icon class="faRedo" [icon]="faRedo"></fa-icon></button>
          }
        </div>
        @if (errorMessage) {
          <div class="feedback invalid-feedback">{{ errorMessage }}</div>
        }
      </div>
    </div>
  }

  @if (this.FlagService.flagServiceObject[9]['finalpaymentJunctureFlag']) {
    <div class="row feedback-module" (click)="feedbackClick()">
      <div class="d-flex p-0">
        <a class="w-100">
          <fa-icon class="text-center ms-3 me-3" [icon]="faSpellCheck"></fa-icon>
          <div class="text">
            <span class="top">{{ 'junctures.captcha.header' | translate }}</span><br>
            <span class="bottom">{{ 'junctures.captcha.status' | translate }}</span>
          </div>
        </a>
      </div>
    </div>
  }
</div>
